export default {
      id: "ce-usage",
      viewBox: "0 0 280 200",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#ce",
      toString: function () {
        return this.url;
      }
    }